export default __webpack_public_path__ + "static/alert-c5edd547c48192df78d7e3d220db3c34.png";